import { render, staticRenderFns } from "./rankings.vue?vue&type=template&id=7135d407&"
import script from "./rankings.ts?vue&type=script&lang=ts&"
export * from "./rankings.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports